export const blogPosts = [
  {
    id: 8,
    title: "Ideas in the Making with Canon Americas Lab at CES 2026",
    date: "January 5, 2026",
    excerpt: "At CES 2026, Canon Americas Lab featured Budbreak Innovations, which uses AI to autonomously monitor and analyze vineyard conditions. Their technology supports optimal cultivation management through disease prediction and yield forecasting.",
    image: require('../assets/images/ces_canon.jpg'),
    category: "Press",
    url: "https://www.usa.canon.com/newsroom/2026/20260105-ces?srsltid=AfmBOorZxkj1lsOwzG23KfGMNx5A8tw94TgRBZ5qojM3FCMoSV60bcBi"
  },
  {
    id: 7,
    title: "Reservoir Farms Launches Sonoma Robotics Hub for Viticulture Innovation",
    date: "December 4, 2025",
    excerpt: "Reservoir Farms and Sonoma County Winegrowers have launched the first on-farm robotics and automation hub dedicated to viticulture. Budbreak Innovations is among the robotics startups joining the program beginning in 2026.",
    image: "https://igrownews.com/wp-content/uploads/2025/10/the-reservoir-latest-news.jpg",
    category: "Press",
    url: "https://igrownews.com/reservoir-latest-news/"
  },
  {
    id: 5,
    title: "Vineyard Robotics: Exploring the Future of Winegrowing - Round Pond Estate",
    date: "September 19, 2025",
    excerpt: "At Round Pond Estate, our 12-acre culinary garden is more than a source of fresh ingredients...",
    image: "https://www.roundpond.com/wp-content/uploads/2025/09/Banner-IMG_0753.jpg",
    category: "Press",
    url: "https://www.roundpond.com/vineyard-robotics-how-round-pond-is-exploring-the-future-of-winegrowing/"
  },
  {
    id: 6,
    title: "Cornell Tech: 11 New Startups Added To Runway Program",
    date: "September 11, 2025",
    excerpt: "Cornell Tech has announced the arrival of 11 new ventures to its campus this September as part of the Runway Startups Program. Budbreak Innovations develops and runs vineyard management robots, starting with scouting for tasks like disease detection and yield estimation.",
    image: "https://cdn.pulse2.com/cdn/2025/09/Cornell-Tech-Logo.jpeg",
    category: "Press",
    url: "https://pulse2.com/cornell-tech-11-new-startups-added-to-runway-program/"
  },
  {
    id: 1,
    title: "Robot matches humans in scouting for vineyard diseases",
    date: "September 8, 2025",
    excerpt: "The latest version of an autonomous robot that can scout for grape diseases in vineyards in near-real time, with an accuracy that matches highly trained human scouts, will one day help track crop-killing pathogens with minimal labor.",
    image: "https://news.cornell.edu/sites/default/files/styles/story_thumbnail_lg/public/2025-09/0908_graperobot2.jpg?itok=HsJ5v6gJ",
    category: "Research",
    url: "https://news.cornell.edu/stories/2025/09/robot-matches-humans-scouting-vineyard-diseases"
  }
];
